import * as React from 'react'
import styled from 'styled-components'
import Spinner from '../../../components/ui/Spinner/Spinner'
import { usePrivacyNotice } from '../../../controllers/TnCAndPN'

const Description = styled.div`
  font-size: 0.875rem;

  table {
    border-collapse: collapse;
    margin: 1rem auto;
  }

  table td,
  table th {
    border: 1px solid;
    padding: 0.5em 1em;
  }
`
const SpinnerContainer = styled.div`
  height: 180px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

export const PrivacyPolicyTitle = () => `The Zing Privacy Notice`

export const PrivacyPolicyDescription = () => {
  const { loading, pnContent, getPrivacyNotice } = usePrivacyNotice()
  const getContent = async () => {
    await getPrivacyNotice()
  }

  React.useEffect(() => {
    if (!pnContent) {
      getContent()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Description>
      {loading && !pnContent ? (
        <>
          <SpinnerContainer>
            <Spinner />
          </SpinnerContainer>
        </>
      ) : (
        <div dangerouslySetInnerHTML={{ __html: pnContent }} />
      )}
    </Description>
  )
}

function PrivacyPolicy(props) {
  return (
    <aside {...props}>
      <PrivacyPolicyDescription />
    </aside>
  )
}

export default PrivacyPolicy
